import {Form, Input} from 'antd';
import {SearchIcon} from "@/theme";

export const SearchFilter = ({name = 'search', width = 300, ...rest}) => {
    const form = Form.useFormInstance();

    return (
        <>
            <Form.Item
                name={name}
                noStyle
            >
                <Input
                    placeholder="input search text"
                    style={{
                        width,
                    }}
                    suffix={(
                        <>
                            <SearchIcon
                                className={'input_icon'}
                                onClick={form.submit}
                            />
                        </>
                    )}
                    {...rest}
                />
            </Form.Item>
        </>
    );
}